export default "__VITE_ASSET__fa6b6c45__"